import { real as viemReal } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const real = {
  displayName: 'Re.al',
  runtime: 'evm',
  viemChain: viemReal,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 're-al' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
